import PrayTimes from '~/lib/PrayTimes'
import moment from 'moment';

export default class PrayerService {
  constructor() {
    this.prayTimes = new PrayTimes();

    this.settings = { // default options
      format: '12h',
      timezone: 'auto',
      dst: 'auto',
      method: 'ISNA',
      adjust: {
        asr: 'Standard'
      },
      
      tune: {}
    }

    this.prayTimes.setMethod('ISNA');

    this.prayerNames = {
      'fajr': 'Fajr',
      'sunrise': 'Sunrise',
      'dhuhr': 'Dhuhr',
      'asr': 'Asr', // sunset: 'Sunset', 
      'maghrib': 'Maghrib',
      'isha': 'Isha'
    };
  }

  /**
   * Get Prayer times
   * @todo Currect date calculation using moment
   * @param {any} date 
   * @param {any} latLng 
   * @param {number} [days=1] 
   * @param {any} [dateKeyFormat=null] 
   * @returns 
   */
  getTimes(date, latLng, settings, days = 1, dateKeyFormat = null) {
    if(settings.method) {
      this.prayTimes.setMethod(settings.method);
    }

    if(settings.asr) {
      this.prayTimes.adjust({asr: settings.asr});
    }

    let currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + days - 1);

    let dateKey;
    let results = {};
    while (currentDate <= endDate) {
      let times = this.prayTimes.getTimes(
        date,
        latLng,
        settings.timezone || this.settings.timezone, 
        settings.dst || this.settings.dst, 
        settings.format || this.settings.format
      );

      if (dateKeyFormat) {
          dateKey = moment(currentDate).format(dateKeyFormat);
      } else {
          dateKey = currentDate.toDateString();
      }

      results[dateKey] = times;
      currentDate.setDate(currentDate.getDate() + 1);  // next day
    }

    if(days === 1) {
      return Object.values(results)[0];
    } else {
      return results;
    }
  }
}


// WEBPACK FOOTER //
// ./src/lib/PrayerService.js